<div class="row col-md-12 d-flex align-items-center pb-1">
    <div class="col-6">
        <h6 class="pb-0"><b>View Fees</b></h6>
        <a href="https://www.uscis.gov/sites/default/files/document/forms/g-1055.pdf" target="_blank" rel="noopener noreferrer">Check here</a> for USCIS Fee Schedule Link
    </div>
    <div class="col-md-6 pull-right">
        <button type="button" pButton label="Reset" (click)="resetFeeCalucation()" [disabled]="disabledControls"
            class="p-button-outlined pull-right"></button>
    </div>
</div>
<form (ngSubmit)="postFeeCalculation()" #feeCalculationForm="ngForm">
    <div class="row">
        <div class="col pr-0">
            <p-table [value]="feeCalculation" class="uscis-table" dataKey="feeTypeCode" editMode="row">
                <ng-template pTemplate="header">
                    <tr>
                        <th colspan="3">Fee type</th>
                        <th colspan="3">Fee Calculation</th>
                        <th colspan="2">Amount</th>
                        <th style="width:8rem;text-align:center">Action</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="item">
                        <td colspan="3">
                            {{item.feeTypeName}} 
                            <span *ngIf="item.rule" class="mat-icon" [matTooltip]="formatTooltip(item.rule)" matTooltipPosition="right" matTooltipClass="custom-tooltip">
                                <i class="material-icons align-bottom">info_outline</i>
                            </span>
                        </td>
                        <td colspan="3">
                            <span *ngIf="item.isCustomized === 1">Set by user</span>
                            <span *ngIf="!item.isCustomized && item.rule">System Generated <br /> <small>{{item.ruleApplied}}</small></span>
                            <span *ngIf="!item.isCustomized && !item.rule">Fixed</span>
                        </td>
                        <td colspan="2">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input pInputText type="text" name="applicableFee" [(ngModel)]="item.applicableFee"
                                        #applicableFee="ngModel" maxlength="5" [disabled]="disabledControls"
                                        pattern="^[0-9]*$" min="0" required />
                                    <div
                                        *ngIf="feeCalculationForm.controls['applicableFee'].touched && feeCalculationForm.controls['applicableFee'].invalid">
                                        <span class="invalid-message"
                                            *ngIf="feeCalculationForm.controls['applicableFee'].errors?.required">
                                            {{getGlobalErrorMessages('REQUIRED')}}
                                        </span>
                                        <span class="invalid-message"
                                            *ngIf="feeCalculationForm.controls['applicableFee'].invalid">
                                            {{getGlobalErrorMessages('INVALID_NUMBER')}}
                                        </span>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{item.applicableFee | currency: 'USD'}}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td style="text-align:center">
                            <button [disabled]="disabledControls || enableEdit" *ngIf="!editing" pButton pRipple
                                type="button" pInitEditableRow icon="pi pi-pencil"
                                (click)="onRowEditInit(item); updateControls(true);"
                                class="p-button-rounded p-button-text"></button>
                            <button [disabled]="disabledControls || feeCalculationForm.invalid" *ngIf="editing" pButton pRipple
                                type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(item);updateControls(false);"
                                class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                            <button [disabled]="disabledControls" *ngIf="editing" pButton pRipple type="button"
                                pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(item, ri);updateControls(false);"
                                class="p-button-rounded p-button-text p-button-danger"></button>
                        </td>
                    </tr>
                </ng-template>
                <!-- Footer (for total quantity) -->
                <ng-template pTemplate="footer">
                    <tr>
                        <td class="footer-cell" colspan="6"><strong>Total</strong></td>
                        <td class="footer-cell">${{feeTotal}}.00</td>                        
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
    <!-- <div class="row pt-3 pb-3">
        <div class="col-md-8">
            <label style="padding-left:17px"><b>Total</b></label>
        </div>
        <div class="col-md-4">
            <label style="padding-left:46px">${{feeTotal}}.00</label>
        </div>
    </div> -->
    <div class="row col-md-12 pt-3">
        <button pButton type="submit" label="Save" icon="pi pi-save"
            [ngClass]="feeCalculationForm.invalid  || disabledControls ? 'btn-success button-width-icon-left mr-3 pl-4 pr-4 btn-success_disabled save-btn':'btn-success button-width-icon-left mr-3  pl-4 pr-4 save-btn'"
            [disabled]="feeCalculationForm.invalid  || disabledControls"></button>
    </div>
</form>